'use strict';

/**
 *  1) Styles at the top of file.
 *  !!! Do not delete, this is for webpack building. !!! All scss files must be included in /assets/src/scss/main.scss
 */
import '../scss/main.scss';
/**
 * 2) Import External (3d-part) JS/jQuery Libs, Extensions like: bootstrap, datepicker, fadeSlider, ect.
 * !!! Import Only required components of Bootstrap (NOT whole library).
 */
// import Modal from 'bootstrap/js/dist/modal'; // uncomment for use

/**
 *  3) Your custom modules and call function here
 */
// Test examples, to show usage approach. Can be deleted
// import {ajaxStartExample} from "./modules/ajax-start-example";
// End test examples. Can be deleted

import { slickSliders } from "./modules/slick-slider";
import { headerFooter } from "./parts/headerfooter";
import { darkMode } from "./parts/darkmode";
import { scrollingNumbers } from "./parts/scrollingnumbers";
import { postsFilter } from "./parts/postsfilter";
import { search } from "./parts/search";
jQuery(document).on("ready", function () {
  /**
   * To use $ symbol inside your function you should pass jQuery variable as param of function
   */
  // Test examples, to show usage approach. Can be deleted

  // ajaxStartExample(jQuery); // AJAX test example
  // End test examples. Can be deleted

  slickSliders();
  var rellax = new Rellax('.rellax');
  headerFooter();
  darkMode();
  scrollingNumbers();
  postsFilter();
  search();
  jQuery(document).ready(function ($) {
    var shareButtons = document.querySelector(".share-buttons.d-none.d-lg-block");
    var contentSection = document.querySelector(".content-section-news");
    if (!shareButtons || !contentSection) return; // Ensure elements exist

    function updateStickyPosition() {
      var contentRect = contentSection.getBoundingClientRect();
      var shareRect = shareButtons.getBoundingClientRect();
      if (contentRect.top <= 100 && contentRect.bottom - shareRect.height >= 30) {
        shareButtons.style.position = "fixed";
        shareButtons.style.top = "100px"; // Adjust as needed
      } else if (contentRect.bottom - shareRect.height < 20) {
        shareButtons.style.position = "absolute";
        shareButtons.style.top = "".concat(contentSection.clientHeight - shareButtons.clientHeight, "px");
      } else {
        shareButtons.style.position = "absolute";
        shareButtons.style.top = "10px";
      }
    }
    window.addEventListener("scroll", updateStickyPosition);
    window.addEventListener("resize", updateStickyPosition);
    updateStickyPosition(); // Run once on load
  });

  // // Wait until the page is fully loaded
  // window.addEventListener('load', function () {
  //     // Check if there's a hash in the URL (like #section1)
  //     if (window.location.hash) {
  //       // Get the target element using the hash
  //       const targetElement = document.querySelector(window.location.hash);

  //       // If the target element exists, scroll to it with an offset (e.g., for fixed header)
  //       if (targetElement) {
  //         window.scrollTo({
  //           top: targetElement.offsetTop - 100, // Adjust by your header's height (e.g., 60px)
  //           behavior: 'smooth' // Optional: Smooth scroll
  //         });
  //       }
  //     }
  //   });
});